






import {Component, Mixins} from 'vue-property-decorator';
import AnalyticsMixin from "@mixins/AnalyticsMixin";

import MainPage from "@share/main/Main.vue";
import { Route } from "vue-router";
import { NavigationGuardNext } from "vue-router/types/router";

@Component({
    name: 'MainView',
    components: { MainPage },
    beforeRouteEnter (
        to: Route,
        from: Route,
        next: NavigationGuardNext
    ): void {
        next(vm => {
            vm.$store.dispatch("setPageTitle");
        })
    }
})
export default class MainView extends Mixins(AnalyticsMixin) {
    async activated() {
        this.sendScreenView('Main');
     }
}
